/**
 * Turning a product RECORD into the text on a card.
 *
 * Its own module because bubble.tsx imports chat.css, which a test runner cannot
 * resolve — and these two functions are the only place a stored machine value
 * becomes words on a customer's shop page, so they are exactly what wants
 * testing directly.
 */

/**
 * A stock token as a shopper reads it.
 *
 * The vocabulary is the record's (ProductAvailabilitySchema), and an unrecognised
 * value renders as NOTHING rather than as its raw token: "unknown" or a value
 * added to the enum later must never appear on a customer's page as machine
 * text, and claiming a state we do not have would be worse than silence.
 */
export function stockLabel(availability: string): string | null {
  switch (availability) {
    case "in_stock":
      return "In stock";
    case "out_of_stock":
      return "Out of stock";
    case "preorder":
      return "Pre-order";
    case "discontinued":
      return "Discontinued";
    default:
      return null;
  }
}

/** Price as stored, with its currency. Never reformatted: the record's own
 *  formatting is the truthful one, and a symbol map would be us inventing how
 *  the merchant writes money. */
export function priceLabel(price: string | null, currency: string | null): string | null {
  if (!price) return null;
  return currency ? `${price} ${currency}` : price;
}

/** The note beside a discounted price: the figure shown assumes this code. */
export function discountNote(code: string | null | undefined): string | null {
  return code ? `with discount code ${code}` : null;
}
